import PidRegistration from 'layouts/Features/PidRegistration'
import React from 'react'
import { useState } from "react";
import { getApiHeader } from 'utlis/commonfunctions';
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { ThreeDots } from 'react-loader-spinner'



const SERVER_URL = process.env.REACT_APP_API_URL;


const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // backgroundColor: "rgba(255, 255, 255, 0.8)",
    backdropFilter: "blur(1px)",
    zIndex: 9999,
  },
};

function NonPidInput() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    retailer_name: "",
    retailer_company_name: "",
    retailer_abn: "",
    retailer_address_line_1: "",
    retailer_address_line_2: "",
    retailer_city: "",
    retailer_state: "",
    retailer_country: 234,
    retailer_post_code: "",
    email: "",
    email_confirmation: "",
    retailer_mobile: "",
  });
  const [error, SetError] = useState({
    retailer_name: false,
    retailer_company_name: false,
    retailer_abn: false,
    retailer_address_line_1: false,
    retailer_address_line_2: false,
    retailer_city: false,
    retailer_state: false,
    retailer_country: false,
    retailer_post_code: false,
    email: false,
    email_confirmation: false,
    retailer_mobile: false,
  });

  const [errorMessage, setErrorMessage] = useState({
    retailer_name: "",
    retailer_company_name: "",
    retailer_abn: "",
    retailer_address_line_1: "",
    retailer_address_line_2: "",
    retailer_city: "",
    retailer_state: "",
    retailer_country: "",
    retailer_post_code: "",
    email: "",
    email_confirmation: "",
    retailer_mobile: "",
  })

const[buttonView,setButtonView]=useState(false)



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    const headers = await getApiHeader()
    axios.post(`${SERVER_URL}non-pid-registration`, formData, {
      headers: headers
    })
      .then(response => {
        console.log("response", response.data.message)
        setLoading(false)
        toast.success(response?.data?.message);
        setFormData({
          retailer_name: "",
          retailer_company_name: "",
          retailer_abn: "",
          retailer_address_line_1: "",
          retailer_address_line_2: "",
          retailer_city: "",
          retailer_state: "",
          retailer_country: "",
          retailer_post_code: "",
          email: "",
          email_confirmation: "",
          retailer_mobile: "",
        }
        )


      })
      .catch(error => {
        setLoading(false)
        setButtonView(false)
        const errorMessage = error?.response?.data?.message;
        if (typeof errorMessage === 'object') {
          Object.keys(errorMessage).forEach(key => {
            errorMessage[key].forEach(message => {

              SetError(prevError => ({
                ...prevError,
                [key]: true
              }));
              setErrorMessage(prevError => ({
                ...prevError,
                [key]: message
              }));
              // toast.error(message);
            });
          });
        } else {
          toast.error(errorMessage);
          setLoading(false)
        }
      })
  };

 
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "retailer_mobile") {
      if (/^\d{0,10}$/.test(value)) {
        console.log("entered");
        setFormData({ ...formData, [name]: value });
      }
    } else if (name === 'retailer_account_number') {
      if (/^\d{0,20}$/.test(value)) {  
        setFormData({ ...formData, [name]: value });
      }
    }else if (name === 'retailer_name') {
      if (/^[a-zA-Z0-9 ]{0,50}$/.test(value)) {  
          setFormData({ ...formData, [name]: value });
      }
  }
  else if (name === 'retailer_post_code') {
    if (/^\d{0,4}$/.test(value)) {
      setFormData({ ...formData, [name]: value });
    }
  }else if (name === 'retailer_abn') {
    if (/^\d{0,11}$/.test(value)) {  
      setFormData({ ...formData, [name]: value });
    }
  }
  





  
   else {
      setFormData({
        ...formData,
        [name]: value
      });
    }

      SetError({
        ...error,
        [name]: false
      })
      setButtonView(true)

  };

 

  return (
    <>
      <div>
        {loading && (
          <div style={styles.wrapper}>
            <ThreeDots
              visible={loading}
              height="80"
              width="80"
              color="#C11D6C"
              radius="9"
              ariaLabel="three-dots-loading"
            />
          </div>
        )}
        <div className="formbold-main-wrapper">
          <div className="formbold-form-wrapper">
            <h3 style={{ textAlign: "center" }}>Non PID Retailer Registration</h3>
            <p style={{ textAlign: "center" }}>Enter the details to create Non PID retailer.</p>
            <form action="" method="" onSubmit={handleSubmit} autoComplete='off'>
              <div className="formbold-mb-5">
                <label htmlFor="name" className="formbold-form-label">
                  Retailer Name <span class="astrix-color">*</span>
                </label>
                <input
                  type="text"
                  name="retailer_name"
                  id="name"
                  placeholder="Enter first name and last name "
                  className={error.retailer_name ? "formbold-form-input form-error" : "formbold-form-input"}
                  value={formData.retailer_name}
                  onChange={handleChange}
                  required={true}
                  autoComplete='off'
                />
                {error.retailer_name && (
                  <p className="error-label">{errorMessage.retailer_name} </p>
                )}
              </div>
              <div className="formbold-mb-5">
                <label htmlFor="phone" className="formbold-form-label">
                  Company/Store Name <span class="astrix-color">*</span>
                </label>
                <input
                  type="text"
                  name="retailer_company_name"
                  id="phone"
                  placeholder="Enter Company name/Trading name."
                  value={formData.retailer_company_name}
                  onChange={handleChange}
                  className={error.retailer_company_name ? "formbold-form-input form-error" : "formbold-form-input"}
                  required={true}
                  autoComplete='off'
                />
                {error.retailer_company_name && (
                  <p className="error-label">{errorMessage.retailer_company_name} </p>
                )}
              </div>
              <div className="formbold-mb-5">
                <label htmlFor="email" className="formbold-form-label">
                  ABN 
                </label>
                <input
                  type="text"
                  name="retailer_abn"
                  id="email"
                  placeholder="Active ABN is mandatory"
                  className={error.retailer_abn ? "formbold-form-input form-error" : "formbold-form-input"}
                  value={formData.retailer_abn}
                  onChange={handleChange}
                  maxLength={11}
                  
                  autoComplete='off'
                />
                {error.retailer_abn && (
                  <p className="error-label">{errorMessage.retailer_abn} </p>
                )}
              </div>
              <div className="formbold-mb-5">
                <label htmlFor="email" className="formbold-form-label">
                  Company/Store address <span class="astrix-color">*</span>
                </label>
                <input
                  type="text"
                  name="retailer_address_line_1"
                  id="email"
                  placeholder="Address Line 1"
                  className={error.retailer_address_line_1 ? "formbold-form-input form-error" : "formbold-form-input"}
                  value={formData.retailer_address_line_1}
                  onChange={handleChange}
                  required={true}
                  autoComplete="new-password"
                />
                {error.retailer_address_line_1 && (
                  <p className="error-label">{errorMessage.retailer_address_line_1} </p>
                )}
              </div>
              <div className="formbold-mb-5">
                <label htmlFor="email" className="formbold-form-label">
                </label>
                <input
                  type="text"
                  name="retailer_address_line_2"
                  id="email"
                  placeholder="Address Line 2"
                  className={error.retailer_address_line_2 ? "formbold-form-input form-error" : "formbold-form-input"}
                  value={formData.retailer_address_line_2}
                  onChange={handleChange}
                  
                  autoComplete="new-password"
                />
                {error.retailer_address_line_2 && (
                  <p className="error-label">{errorMessage.retailer_address_line_2} </p>
                )}
              </div>
              <div className="formbold-mb-5 formbold-pt-3">
                
                <div className="flex flex-wrap formbold--mx-3">
                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                    <label htmlFor="Address_Line_1" className="formbold-form-label">
                        City <span class="astrix-color">*</span>
                      </label>
                      <input
                        type="text"
                        name="retailer_city"
                        id="area"
                        placeholder="Enter City"
                        className={error.retailer_city ? "formbold-form-input form-error" : "formbold-form-input"}
                        value={formData.retailer_city}
                        onChange={handleChange}
                        required={true}
                        autoComplete="new-password"
                      />
                      {error.retailer_city && (
                        <p className="error-label">{errorMessage.retailer_city} </p>
                      )}
                    </div>
                  </div>

                  <div className="w-full sm:w-half formbold-px-3">
                  <label htmlFor="Address_Line_1" className="formbold-form-label">
                        State <span class="astrix-color">*</span>
                      </label>
                    <select
                      className={error.retailer_state ? "formbold-form-input form-error" : "formbold-form-input"}
                      name="retailer_state"
                      id="occupation"
                      value={formData.retailer_state}
                      onChange={handleChange}
                      required={true}
                      autoComplete='off'
                    >
                      <option value="">Select State</option>
                      <option value="Act">ACT</option>
                      <option value="NSW">NSW</option>
                      <option value="NIT">NIT</option>
                      <option value="QLD">QLD</option>
                      <option value="SA">SA</option>
                      <option value="TAS">TAS</option>
                      <option value="VIC">VIC</option>
                      <option value="WA">WA</option>
                    </select>
                    {error.retailer_state && (
                      <p className="error-label">{errorMessage.retailer_state}</p>
                    )}
                  </div>


                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                    <label htmlFor="Address_Line_1" className="formbold-form-label">
                        Post Code <span class="astrix-color">*</span>
                      </label>
                      <input
                        type="text"
                        name="retailer_post_code"
                        id="post-code"
                        placeholder="Post Code"
                        className={error.retailer_post_code ? "formbold-form-input form-error" : "formbold-form-input"}
                        value={formData.retailer_post_code}
                        onChange={handleChange}
                        maxLength={4}
                        required={true}
                        autoComplete="new-password"
                      />
                      {error.retailer_post_code && (
                        <p className="error-label">{errorMessage.retailer_post_code} </p>
                      )}
                    </div>
                  </div>

                  <div className="w-full sm:w-half formbold-px-3">
                  <label htmlFor="Address_Line_1" className="formbold-form-label">
                        Country <span class="astrix-color">*</span>
                      </label>
                    <select
                      className={error.retailer_country ? "formbold-form-input form-error" : "formbold-form-input"}
                      name="retailer_country"
                      id="retailer_country"
                    >
                      <option value="Australia">Australia</option>

                    </select>
                    {error.retailer_country && (
                      <p className="error-label">{errorMessage.retailer_country}</p>
                    )}
                  </div>

                </div>
              </div>

              <div className="formbold-mb-5">
                <label htmlFor="email" className="formbold-form-label">
                  Email <span class="astrix-color">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Enter your email "
                  className={error.email ? "formbold-form-input form-error" : "formbold-form-input"}
                  value={formData.email}
                  onChange={handleChange}
                  autoComplete='off'
                />
                {error.email && (
                  <p className="error-label">{errorMessage.email}</p>
                )}
              </div>
              <div className="formbold-mb-5">
                <label htmlFor="email" className="formbold-form-label">
                  Confirm Email <span class="astrix-color">*</span>
                </label>
                <input
                  type="email"
                  name="email_confirmation"
                  id="email"
                  placeholder="Confirm your email"
                  className={error.email_confirmation ? "formbold-form-input form-error" : "formbold-form-input"}
                  value={formData.email_confirmation}
                  onChange={handleChange}
                  autoComplete='off'
                />
                {error.email_confirmation && (
                  <p className="error-label">{errorMessage.email_confirmation}</p>
                )}
              </div>
              <div className="formbold-mb-5">
                <label htmlFor="phone" className="formbold-form-label">
                  {" "}
                  Enter Your Phone number{" "} <span class="astrix-color">*</span>
                </label>
                 <input
                    type="tel"
                    name="retailer_mobile"
                    id="phone"
                    value={formData.retailer_mobile}
                    onChange={handleChange}
                    placeholder="Enter your phone number "
                    className={error.retailer_mobile ? "formbold-form-input form-error" : "formbold-form-input"}
                    pattern={"0[0-9]{9}"}
                    required={true}
                    autoComplete='off'
                  />
                {error.retailer_mobile && (
                  <p className="error-label">{errorMessage.retailer_mobile} </p>
                )}
              </div>
             
               <div>
               <button className="formbold-btn" type="submit" >Submit</button>
             </div>
             
             

            </form>
          </div>
        </div>
      </div>
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');\n  * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n  body {\n    font-family: \"Inter\", Arial, Helvetica, sans-serif;\n  }\n  .formbold-mb-5 {\n    margin-bottom: 20px;\n  }\n  .formbold-pt-3 {\n    padding-top: 12px;\n  }\n  .formbold-main-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 48px;\n  }\n\n  .formbold-form-wrapper {\n    margin: 0 auto;\n    max-width: 550px;\n    width: 100%;\n    background: white;\n  }\n  .formbold-form-label {\n    display: block;\n    font-weight: 500;\n    font-size: 16px;\n    color: #07074d;\n    margin-bottom: 12px;\n  }\n  .formbold-form-label-2 {\n    font-weight: 600;\n    font-size: 20px;\n    margin-bottom: 20px;\n  }\n\n  .formbold-form-input {\n    width: 100%;\n    padding: 12px 24px;\n    border-radius: 6px;\n    border: 1px solid #e0e0e0;\n    background: white;\n    font-weight: 500;\n    font-size: 16px;\n    color: #6b7280;\n    outline: none;\n    resize: none;\n  }\n  .formbold-form-input:focus {\n    border-color: #6a64f1;\n    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);\n  }\n\n  .formbold-btn {\n    text-align: center;\n    font-size: 16px;\n    border-radius: 6px;\n    padding: 14px 32px;\n    border: none;\n    font-weight: 600;\n    background-color: #6a64f1;\n    color: white;\n    width: 100%;\n    cursor: pointer;\n  }\n  .formbold-btn:hover {\n    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);\n  }\n\n  .formbold--mx-3 {\n    margin-left: -12px;\n    margin-right: -12px;\n  }\n  .formbold-px-3 {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n  .flex {\n    display: flex;\n  }\n  .flex-wrap {\n    flex-wrap: wrap;\n  }\n  .w-full {\n    width: 100%;\n  }\n  @media (min-width: 540px) {\n    .sm\\:w-half {\n      width: 50%;\n    }\n  }\n"
        }}
      />

    </>
   
  )
}

export default NonPidInput